import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-instagram-icon',
  templateUrl: './instagram-icon.component.html',
  styleUrls: ['./instagram-icon.component.scss']
})
export class InstagramIconComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
